const wrappersTypes = {
  bold: {
    id: 'bold',
    className: 'ws-bold',
    tagName: 'b',
    keyCode: 'KeyB',
  },
  italic: {
    id: 'italic',
    className: 'ws-italic',
    tagName: 'i',
    keyCode: 'KeyI',
  },
  underline: {
    id: 'underline',
    className: 'ws-underline',
    tagName: 'u',
    keyCode: 'KeyU',
  },
  customColor: {
    id: 'custom-color',
    className: 'ws-custom-color',
    tagName: 'ws-color',
  },
  link: {
    id: 'link',
    className: 'ws-link',
    tagName: 'a',
    keyCode: 'KeyK',
  },
  strikethrough: {
    id: 'strikethrough',
    className: 'ws-strikethrough',
    tagName: 's',
    keyCode: 'KeyX',
    shiftKey: true,
  },
  decoration: {
    id: 'decoration',
    className: 'ws-decoration',
    tagName: 'ws-decoration',
  },
};

export default wrappersTypes;
